export default __webpack_public_path__ + "static/media/img-video-earn-30-percent.bc956d1e.jpg";